// extracted by mini-css-extract-plugin
module.exports = {"mobileSeparator":"second-degree-contact-second-degree-contact-mobileSeparator-f8daf9e3","separator":"second-degree-contact-second-degree-contact-separator-faf24dcf"};